import React, { useEffect } from 'react'
import { useThree } from '@react-three/fiber'
import { Html } from '@react-three/drei'
import './unifiedUI.scss'

/**
 * ContactOverlay Component
 * 
 * Simple 3D scene for contact information
 * Displays contact cards with LoadingScreen styling
 */

const ContactOverlay = () => {
  const { camera } = useThree()
  
  // Set camera to look at the scene
  useEffect(() => {
    camera.lookAt(0, 0, 0)
  }, [camera])
  
  return (
    <>
      {/* Lighting */}
      <hemisphereLight 
        skyColor="#4b6cb7" 
        groundColor="#182848" 
        intensity={2}
      />
      
      {/* HTML overlay with contact content - positioned to fill camera view */}
      <Html
        position={[0, 0, 0]}
        center
        transform={false}
        zIndexRange={[100, 0]}
        style={{
          width: '100vw',
          height: '100vh',
          pointerEvents: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem',
            alignItems: 'center',
            padding: '2rem',
            color: 'white',
            maxWidth: '80vw',
            width: '100%'
          }}>
            {/* Welcome message overlay (2D HTML above canvas) */}
            <div className="text-box" style={{ textAlign: 'center', marginBottom: '1rem' }}>
              <h3 className="text-heading-1" style={{ marginBottom: '0.5rem' }}>
                Let's Connect
              </h3>
              <p className="text-body-large" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                Please don't hesitate to reach out. I would love to connect
                <span className="material-symbols-rounded" style={{ fontSize: '1.5em' }}>
                  waving_hand
                </span>
              </p>
            </div>

            {/* Contact buttons styled like LoadingScreen */}
            <div className="response-options" style={{ width: '100%', maxWidth: '800px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem', alignItems: 'stretch' }}>
              {/* Email Button */}
              <button 
                className="response-option"
                onClick={() => window.open('mailto:bjorn@grauers.com', '_blank', 'noopener,noreferrer')}
                style={{ flex: '1 1 auto', maxHeight: '100%' }}
              >
                <div className="response-header">
                  <h4 className="text-heading-2">Email</h4>
                  <div className="btn-base round">
                    <span className="material-symbols-rounded" style={{ fontSize: '24px', fontFamily: 'Material Symbols Rounded', lineHeight: '24px', display: 'block' }}>
                      mail
                    </span>
                  </div>
                </div>
              </button>
              {/* LinkedIn Button */}
              <button 
                className="response-option"
                onClick={() => window.open('https://www.linkedin.com/in/bjorngrauers/', '_blank', 'noopener,noreferrer')}
                style={{ flex: '1 1 auto', maxHeight: '100%' }}
              >
                <div className="response-header">
                  <h4 className="text-heading-2">LinkedIn</h4>
                  <div className="btn-base round">
                    <img 
                      src="/graphics/logo/logo-linkedin-w.webp" 
                      alt="LinkedIn"
                      style={{ width: '24px', height: '24px', objectFit: 'contain', display: 'block' }}
                    />
                  </div>
                </div>
              </button>
            </div>
          </div>
        </Html>
    </>
  )
}

export default ContactOverlay
